import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { TaskEventProvider } from './domain/events/task_event_provider';
import { ToDoEventProvider } from './domain/events/todo_event_provider';
import { ToDoCommands } from './domain/todo_commands';
import { PredefinedTaskRepository } from './repository/predefined-task.repository';
import { TaskRepository } from './repository/task.repository';
import { ToDoRepository } from './repository/todo.repository';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [TaskRepository, ToDoRepository, PredefinedTaskRepository],
})
export class ToDoModule {
  static forRoot(): ModuleWithProviders<ToDoModule> {
    return {
      ngModule: ToDoModule,
      providers: [
        {
          provide: ToDoCommands,
        },
        {
          provide: ToDoEventProvider,
        },
        {
          provide: TaskEventProvider,
        },
      ],
    };
  }
}
